import React from 'react';

import { Media, SimpleImage } from '$partials/media';
import { Collapsible, CollapsibleContent, CollapsibleContextConsumer, CollapsibleHeading } from '$partials/base';
import { IconAdd, IconMinus } from '$partials/icons';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/modules.d.ts').FaqBlock}
 */

const Faq = ({
    title,
    sections
}) => {
    const bgColor = 'bg-surface-panel-white';
    return (
        <section className={`${bgColor} col-padding pt-24 pb-16 grid sm:grid-cols-12 gap-y-40 sm:gap-y-0 gap-x-16 rounded-lg`}>
            <div className='w-full col-span-3 md:col-span-6'>
                <h2 className='type-style-sans-h1'>
                    {title}
                </h2>
            </div>

            <div className='col-span-9 sm:pl-40 md:pl-0 md:col-span-6'>
                {sections.map((item, idx) => {
                    return (
                        <Collapsible
                            className='w-full'
                            id={`faq-accordion-${idx}`}
                            isOpened={false}
                            key={`faq-accordion-${idx}`}>
                            <CollapsibleHeading className='cursor-pointer w-full'>
                                <CollapsibleContextConsumer>
                                    {({ isOpened }) => (
                                        <span className='flex items-center justify-between py-16 border-t border-border-default'>
                                            <span className='type-style-sans-body-med'>
                                                {item.title}
                                            </span>
                                            <span aria-hidden='true'>
                                                {isOpened ? <IconMinus /> : <IconAdd/>}
                                            </span>
                                        </span>
                                    )}
                                </CollapsibleContextConsumer>
                            </CollapsibleHeading>
                            <CollapsibleContent className='mt-10'>
                                <div
                                    className='rich-text type-style-sans-body pb-16'
                                    dangerouslySetInnerHTML={{ __html: item.text}} />

                            </CollapsibleContent>
                        </Collapsible>
                    );
                })}
            </div>
        </section>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default Faq;
